import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';

@Component({
	selector: 'au-mat-chips',
	templateUrl: './au-chips.component.html',
	styleUrls: ['./au-chips.component.scss'],
	imports: [MatChipsModule, MatIconModule],
})
export class AuChipsComponent {
	@Input() chips = [];
	@Output() deleteChip = new EventEmitter<any>();

	deleteChipHandler(chip) {
		this.deleteChip.emit(chip);
	}

	getName(chip: any): string {
		if (chip.name) {
			return chip.name;
		} else if (chip.file?.name) {
			return chip.file.name;
		} else {
			return '-';
		}
	}
}
